import { memo } from "react";

interface HtmlProps {
  className?: string;
  content?: string;
}

export const Html = memo(({ content, className }: HtmlProps) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  );
});
